<script lang="ts">
	import type { ExhibitionsPagePageData } from './types';
	import { getExhibitionJsonLd } from '#lib/features/seo/utils/getExhibitionJsonLd/getExhibitionJsonLd.js';
	import { ExhibitionsPage } from '#lib/websites/exhibitions/pages/ExhibitionsPage/index.js';
	import { page } from '$app/state';
	import { JsonLd } from '$global/features/seo/components/JsonLd';

	// Here, not in ExhibitionsPage, which is a shared drop-page layout.
	let data = $derived(page.data as ExhibitionsPagePageData);
	let jsonLd = $derived(getExhibitionJsonLd(data.exhibition, data.seo.url));
</script>

{#if jsonLd}
	<JsonLd data={jsonLd} />
{/if}

<ExhibitionsPage />
